module.exports = "/img/calculator-banner-1.057eaab6.png";